import PropTypes from 'prop-types';
import React from 'react';
import styled from '@emotion/styled';
import {
  ssColorDeception,
  ssColorSpecOps,
  ssColorSurveillance,
  ssColorEncryption,
  mediaBreakpointUpMD,
  mediaBreakpointUpLG,
  mediaBreakpointUpXL,
} from '../constants/style-constants';
import summaryContentType from '../proptypes/summary-content';
import Summary from './Summary';
import Card from './Card';
import CardHeroVideo from './CardHeroVideo';
import { Header4 } from './Typography';
import { vunit } from '../lib/style-helpers';
import ScoreCardSection from './ScoreCardSection';

const borderColor = {
  'special-ops': ssColorSpecOps,
  'hot-risk': ssColorSurveillance,
  deception: ssColorDeception,
  encryption: ssColorEncryption,
  surveillance: ssColorSurveillance,
};

const CardWithBorder = styled(Card)`
  border-top: ${props => props.border && `1px solid ${props.border}`};
`;

const CardImage = styled.img`
  display: block;
  width: 100%;
  margin-top: 1.5rem;
  margin-bottom: ${vunit(4)};
  object-fit: cover;
  height: 205px;

  ${mediaBreakpointUpMD} {
    height: 160px;
  }
  ${mediaBreakpointUpLG} {
    height: 145px;
  }
  ${mediaBreakpointUpXL} {
    height: 160px;
  }
`;

const ScoreCard = ({
  gameTitle,
  imageUrl,
  videoUrl,
  gameKey,
  summary,
  children,
  heroOverride,
}) => {
  const renderHero = () => {
    if (heroOverride) return heroOverride;
    if (videoUrl) return <CardHeroVideo videoUrl={videoUrl} posterURL={imageUrl} playsInline />;
    return <CardImage src={imageUrl} role="presentation" />;
  };

  return (
    <CardWithBorder
      className={`score-card-temp score-card-${gameKey}`}
      id={`score-card-${gameKey}`}
      border={borderColor[gameKey]}
    >
      <Header4 displayFont>{gameTitle}</Header4>
      <ScoreCardSection>
        {renderHero()}
      </ScoreCardSection>
      {summary && (
      <ScoreCardSection>
        <Summary content={summary} />
      </ScoreCardSection>
      )}
      {children}
    </CardWithBorder>
  );
};

ScoreCard.defaultProps = {
  children: null,
  summary: undefined,
  videoUrl: undefined,
  heroOverride: undefined,
};

ScoreCard.propTypes = {
  gameTitle: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  videoUrl: PropTypes.string,
  gameKey: PropTypes.string.isRequired,
  summary: summaryContentType,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  heroOverride: PropTypes.node,
};

export default ScoreCard;
